import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import store from "../store/index";

// Initialize Firebase with configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Geliştirme ortamında Firebase emülatörlerini kullanmak için
// (sadece geliştirme ortamında aktif edilmeli)
if (import.meta.env.DEV) {
  // connectFunctionsEmulator(functions, "localhost", 5001);
}

// Listen for auth state changes
auth.onAuthStateChanged(async (user) => {

  if (user) {
    try {
      // Check if user exists in users collection
      const userRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userRef);
      
      // Create a new user object with auth data
      const userData = { ...user, id: user.uid };
      
      if (userDoc.exists()) {
        // User exists in Firestore, get role and other data
        const firestoreData = userDoc.data();
        userData.role = firestoreData.role;
      } else {
        // User doesn't exist in Firestore, create a new user document
        const newUserData = {
          uid: user.uid,
          id: user.uid,
          email: user.email,
          name: user.displayName || user.email.split('@')[0],
          username: user.displayName || user.email.split('@')[0],
          role: 3,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          agree: false
        };
        
        // Save new user to Firestore
        await setDoc(userRef, newUserData);
        
        // Add role to userData
        userData.role = newUserData.role;
      }
      
      // Update the store with user data including role
      if (store.commit && typeof store.commit === 'function') {
        store.commit('setUser', {...userData, id: user.uid});
      }
    } catch (error) {
      console.error('Error fetching or creating user:', error);
      // Set default role in case of error
      const userData = { ...user, role: 3 };
      if (store.commit && typeof store.commit === 'function') {
        store.commit('setUser', {...userData, id: user.uid});
      }
    }
  } else {
    // User is signed out, clear the store
    if (store.commit && typeof store.commit === 'function') {
      store.commit('logoutUser');
    }
  }
});

export { app, db, auth, storage, functions }; 